import { render, staticRenderFns } from "./VehiculoIndex.vue?vue&type=template&id=63cd90e2"
import script from "./VehiculoIndex.vue?vue&type=script&lang=js"
export * from "./VehiculoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports